export default {
  'message.successSave': 'The {{entity}} was created successfully',
  'message.successUpdate': 'The {{entity}} was updated successfully',
  'message.errorSave': 'An error occurred while creating the {{entity}}',
  'message.errorUpdate': 'An error occurred while updating the {{entity}}',
  'message.errorGet': 'The {{entity}} failed to get',
  'message.errorDownload': 'Error downloading file',
  'message.successDelete': 'The {{entity}} was deleted successfully',
  'message.errorDelete': 'The {{entity}} failed to delete',
  'message.successSentVerificationEmail':
    'Verification email sent successfully',
  'message.pendingEmailVerification': 'Email verification pending',
  'message.errorSentVerificationEmail': 'Error sending verification email',
  'message.delete.explain': 'The {{entity}} was marked as deleted',
  'message.delete.info': 'Delete is only available in edit mode',
  'message.deactivate.info': 'Deactivate {{entity}}',
  'message.delete.warning':
    'Are you absolutely certain you want to delete this {{entity}}?',
  'message.deactivate.warning':
    'Are you sure you want to delete this {{entity}}? It will first be marked as deactivated before deletion.',
  'message.delete.confirm':
    'When you confirm the deletion, the system will take action. It might remove the {{entity}} from a database.',
  'message.inactive.confirm':
    'The entity will be marked as inactive. It will no longer be visible or usable, but not deleted from the system.',
  'message.unassigned.warning':
    'Are you completely sure you want to remove this {{entity}} assignment?',
  'message.unassigned.confirm':
    'When you confirm removing the assignment, the system will take action. It might remove the {{entity}} assignment from a database.',
  'message.unload.title': 'Unsaved changes',
  'message.unload.description':
    'You have unsaved changes. Are you sure you want to leave this page?',
};
